module.exports = __webpack_public_path__ + "static/media/clarityICI.db6232f8.jpg";